export default "/_next/static/images/caregiver2-dfa87acc72cf3ba87fba91fc4eafbe13.png";